import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type {
  IApiUpdateAdRequestBody,
  IApiUpdateAdResponseBody,
} from '../AdsApi.types';
import { useApi } from '~/lib/api/useApi';
import { adQueryKeyFactory } from './useAdQuery';
import { adsQueryKeyFactory } from './useAdsQuery';

export type IUseUpdateAdMutationValues = {
  appId: string;
  adId: string;
  body: IApiUpdateAdRequestBody;
};

export const useUpdateAdMutation = (): UseMutationResult<
  IApiUpdateAdResponseBody,
  unknown,
  IUseUpdateAdMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values) =>
      api.ads.update(values.appId, values.adId, values.body),
    onSuccess: async (updatedAd, values) => {
      const queryKey = adQueryKeyFactory({
        appId: updatedAd.appId,
        adId: updatedAd._id,
      });
      if (queryKey) {
        queryClient.setQueryData(queryKey, updatedAd);
      }

      await queryClient.invalidateQueries({
        queryKey: adsQueryKeyFactory({
          appId: values.appId,
        }),
      });
    },
  });
};
